export const IOS_APP_STORE_URL = 'https://apps.apple.com/us/app/luckynote-message-yourself/id1566320984';
export const ANDROID_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.luckynote';

// This runs only from click handlers, so server-side/prerendered markup keeps
// its safe /register fallback while the actual visitor's device determines the
// destination.
export const getMobileStoreUrl = () => {
    if (typeof navigator === 'undefined') return null;

    const userAgent = navigator.userAgent || '';
    const isIPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

    if (/iPad|iPhone|iPod/i.test(userAgent) || isIPadOS) {
        return IOS_APP_STORE_URL;
    }

    if (/Android/i.test(userAgent)) {
        return ANDROID_PLAY_STORE_URL;
    }

    return null;
};

// Returns false for desktops and unrecognized devices, allowing the link's
// normal /register navigation to continue.
export const redirectToMobileStore = (event) => {
    const storeUrl = getMobileStoreUrl();
    if (!storeUrl) return false;

    event.preventDefault();
    window.location.assign(storeUrl);
    return true;
};
